/**
 * Alpine.js Likers Modal Component
 *
 * Displays a modal with paginated list of users who liked an entity.
 * Triggered by 'open-likers-modal' window event from like button.
 */

import { lockBodyScroll, unlockBodyScroll } from './scroll-lock.js';

export function likersModal() {
    return {
        isOpen: false,
        entityType: null,
        entityId: null,
        likers: [],
        isLoading: false,
        hasMore: false,
        offset: 0,
        total: 0,

        init() {
            window.addEventListener('open-likers-modal', (e) => this.open(e.detail));
        },

        async open({ entityType, entityId, count }) {
            this.entityType = entityType;
            this.entityId = String(entityId);
            this.total = count;
            this.likers = [];
            this.offset = 0;
            this.hasMore = false;
            this.isOpen = true;
            lockBodyScroll();
            await this.loadLikers();
        },

        close() {
            this.isOpen = false;
            unlockBodyScroll();
        },

        async loadLikers() {
            if (this.isLoading) return;
            this.isLoading = true;

            try {
                const token = await window.getApiToken();
                const params = new URLSearchParams({
                    limit: '20',
                    offset: String(this.offset)
                });

                const response = await fetch(
                    `/v1/${this.entityType}/${this.entityId}/likes?${params}`,
                    {
                        headers: { 'X-AUTH-TOKEN': token },
                        credentials: 'include'
                    }
                );

                if (!response.ok) {
                    throw new Error(window.tOr('common.fetch_likers_failed', 'Failed to fetch likers'));
                }

                const data = await response.json();
                this.likers = [...this.likers, ...data.data];
                this.hasMore = data.data.length === 20;
                this.offset += data.data.length;
            } catch (error) {
                window.showError?.(window.tOr('common.load_likers_failed', 'Failed to load likers'));
            } finally {
                this.isLoading = false;
            }
        },

        getUserPhoto(user) {
            if (user.photo) {
                return user.photo;
            }
            const sex = user.sex || 'male';
            return `/img/empty-avatar-${sex === 'female' ? 'f' : 'm'}.png`;
        }
    };
}

if (typeof window !== 'undefined') {
    window.likersModal = likersModal;
}

export default likersModal;
